import { SUPPORT_ACCOUNT_EMAIL } from '@hotjar/webapp/constants/support';

angular.module('hjApp').controller('ModalGrantSupportAccessCtrl', [
    '$scope',
    '$modalInstance',
    'Restangular',
    'UserData',
    function ($scope, $modalInstance, Restangular, UserData) {
        /*************************
         * PRIVATE FUNCTIONS
         *************************/
        /**
         * Grant Access to this organization to Hotjar's support team.
         *
         * @param callback Callback function on response.
         */
        function grantAccessToHotjarSupport() {
            Restangular.one('accounts', UserData.currentSite.account.id)
                .one('organizations', UserData.currentSite.organization.id)
                .one('invitations')
                .one('support')
                .put()
                .then(
                    undefined,
                    // On any error, we just want to log the error and
                    // continue.
                    (response) => {
                        window.Sentry.captureMessage(`Failed to grant access: ${response.data}`);
                        window.Sentry.captureException(response.data);
                    }
                )
                .then(() => $modalInstance.close());
        }

        /*************************
         * SCOPE VARIABLES
         *************************/
        $scope.model = {
            grantAccess: true,
            supportAccountEmail: SUPPORT_ACCOUNT_EMAIL
        };

        /*************************
         * SCOPE FUNCTIONS
         *************************/
        /**
         * Continue to help.
         */
        $scope.continue = function () {
            if ($scope.model.grantAccess) {
                grantAccessToHotjarSupport();
            } else {
                $modalInstance.close();
            }
        };

        /**
         * Close the modal.
         */
        $scope.close = $modalInstance.dismiss;
    }
]);
